import { gql } from '@apollo/client';

export const SUBSCRIPTION_PLANS_QUERY = gql`
  query subscriptionPlans(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    subscriptionPlans(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      subscriptionPlans {
        id
        price
        duration
        planName
        currency
        description
        paymentCycle
        status
        createdAt
        updatedAt
        discountedPercentage
        discountedAmount
      }
      totalPages
      totalCount
    }
  }
`;

export const DELETE_SUBSCRIPTION_PLAN = gql`
  mutation deleteSubscriptionPlan($subscriptionPlanId: ID!) {
    deleteSubscriptionPlan(subscriptionPlanId: $subscriptionPlanId)
  }
`;

export const UPDATE_SUBSCRIPTION_PLAN = gql`
  mutation updateSubscriptionPlan(
    $updateInput: updateSubscriptionPlanInput
    $subscriptionPlanPriceHistoryInputDTO: SubscriptionPlanPriceHistoryInputDTO
  ) {
    updateSubscriptionPlan(
      updateInput: $updateInput
      subscriptionPlanPriceHistoryInputDTO: $subscriptionPlanPriceHistoryInputDTO
    )
  }
`;

export const SUBSCRIPTION_PLANS_BY_ID = gql`
  query subscriptionPlan($id: ID!) {
    subscriptionPlan(id: $id) {
      id
      price
      duration
      planName
      currency
      description
      paymentCycle
      status
      createdAt
      updatedAt
      discountedPercentage
      discountedAmount
    }
  }
`;

export const USER_SUBSCRIPTION_PLANS_BY_ID = gql`
  query userSubscription($id: ID!) {
    userSubscription(id: $id) {
      id
      subscriptionPlan {
        id
        price
        duration
        planName
        currency
        description
        paymentCycle
        status
        createdAt
        updatedAt
        discountedPercentage
        discountedAmount
      }
    }
  }
`;

export const USER_SUBSCRIPTION_PLANS_BY_TRADER_ID = gql`
  query userSubscriptionByTrader($id: ID!) {
    userSubscriptionByTrader(id: $id) {
      id
      deactivationDate
      dealQtyLimit
      dealQtyUnit
      dealOrderLimit
      subscriptionPlan {
        id
        price
        duration
        planName
        currency
        description
        paymentCycle
        status
        createdAt
        updatedAt
        discountedPercentage
        discountedAmount
      }
    }
  }
`;
export const CREATE_USER_SUBSCRIPTION_PLAN = gql`
  mutation createUserSubscription(
    $createInput: createUserSubscriptionInput
    $platformType: PlatformType
  ) {
    createUserSubscription(
      createInput: $createInput
      platformType: $platformType
    ) {
      id
    }
  }
`;

export const CREATE_USER_SUBSCRIPTION_PLAN_PAYMENT = gql`
  mutation createUserSubscriptionPayment(
    $inputDTO: UserSubscriptionPaymentInputDTO
    $platformType: PlatformType
  ) {
    createUserSubscriptionPayment(
      inputDTO: $inputDTO
      platformType: $platformType
    ) {
      id
    }
  }
`;

export const UPDATE_USER_SUBSCRIPTION_PLAN = gql`
  mutation upgradeUserSubscription(
    $updateInput: updateUserSubscriptionInput
    $upgradeSubscriptionHistoryInputDTO: createUpgradeSubscriptionHistoryInput
    $platformType: PlatformType
  ) {
    upgradeUserSubscription(
      updateInput: $updateInput
      upgradeSubscriptionHistoryInputDTO: $upgradeSubscriptionHistoryInputDTO
      platformType: $platformType
    )
  }
`;

export const CALCULATE_SUBSCRIPTION_AMOUNT = gql`
  query calculateSubscriptionAmount(
    $currentUserSubscriptionId: ID
    $subscriptionPlanId: ID
    $couponCode: String
    $traderId: ID
  ) {
    calculateSubscriptionAmount(
      currentUserSubscriptionId: $currentUserSubscriptionId
      subscriptionPlanId: $subscriptionPlanId
      couponCode: $couponCode
      traderId: $traderId
    ) {
      subscriptionAmount
      couponAmount
      sGstAmount
      cGstAmount
      proRataAmount
      grandTotal
      iGstAmount
    }
  }
`;

export const USER_SUBSCRIPTION_PLANS_QUERY = gql`
  query userSubscriptions(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    userSubscriptions(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      userSubscriptions {
        id
        subscriptionPlan {
          id
          planName
          price
          currency
          description
          paymentCycle
          status
          createdAt
          updatedAt
          discountedPercentage
          discountedAmount
        }
      }
      totalCount
      totalPages
    }
  }
`;
